import { createContext, useContext, useState, useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./AuthContext";
import { techniciansApi } from "../services/api";

const FilterMineContext = createContext(null);

export function FilterMineProvider({ children }) {
  const [showOnlyMine, setShowOnlyMine] = useState(
    () => localStorage.getItem("show_only_mine") === "true"
  );

  const toggle = useCallback(() => {
    setShowOnlyMine((prev) => {
      const next = !prev;
      localStorage.setItem("show_only_mine", String(next));
      return next;
    });
  }, []);

  return (
    <FilterMineContext.Provider value={{ showOnlyMine, toggle }}>
      {children}
    </FilterMineContext.Provider>
  );
}

export const useFilterMine = () => useContext(FilterMineContext);

export function useTechnicianLookup() {
  const { user } = useAuth();
  const { data: technicians = [], isLoading, isError } = useQuery({
    queryKey: ["technicians"],
    queryFn: () => techniciansApi.list(),
    staleTime: 300_000,
  });
  const technicianId =
    technicians.find(
      (t) => t.email?.toLowerCase() === user?.email?.toLowerCase()
    )?.id ?? null;
  // isError lets callers tell a lookup outage from a genuinely unlinked account
  return { technicianId, isLoading, isError };
}

export function useMyTechnicianId() {
  return useTechnicianLookup().technicianId;
}
